// Function to add the click event
function addToggleClass() {
    console.log('addToggleClass');
    document.querySelectorAll('.shopify-block .loop-widget-purchase-options-label').forEach(item => {
        // Remove any existing event listener to prevent duplicate handlers
        item.onclick = null;

        // Add the class toggle functionality
        item.onclick = function() {
            // Find the closest .shopify-app-block parent and toggle the class
            const parentAppBlock = item.closest('.shopify-app-block');
            if (parentAppBlock) {
                parentAppBlock.classList.toggle('show-subscription');
            }
        };
    });
}

// Observe for dynamically added or modified elements
const observer = new MutationObserver((mutationsList) => {
    console.log('observer')
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
            // Look for containers with IDs that start with "shopify-block-loop_subscriptions_loop_widget"
            const dynamicContainers = Array.from(document.querySelectorAll('.loop-widget-container'));
          
            dynamicContainers.forEach(container => {
                // Attach the class toggle event to elements within each relevant container
                if (container.querySelector('.loop-widget-purchase-options-label')) {
                    addToggleClass();
                }
            });
        }
    }
});

// Start observing the document for elements with the desired prefix in their ID
observer.observe(document.body, { childList: true, subtree: true });